// extracted by mini-css-extract-plugin
export var container = "_3p-0";
export var error = "_3p-9";
export var label = "_3p-5";
export var light = "_3p-6";
export var md = "_3p-3";
export var sm = "_3p-2";
export var thin = "_3p-8";
export var thinBold = "_3p-7";
export var vertical = "_3p-4";
export var xs = "_3p-1";